var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarningPaidPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 56,
    viewBox: "0 0 144 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9982 56.7484C69.6613 56.5779 70.2911 56.3246 70.876 56H87.535C86.5529 57.9551 86 60.163 86 62.5C86 70.5081 92.4919 77 100.5 77C103.597 77 106.468 76.029 108.823 74.3747C110.822 75.4132 113.092 76 115.5 76C123.508 76 130 69.5081 130 61.5C130 53.4919 123.508 47 115.5 47C112.403 47 109.532 47.971 107.177 49.6253C105.655 48.8343 103.974 48.3053 102.196 48.0981C100.74 44.1773 99.9892 39.6009 101.5 35.5C99.1 32.7 96.8333 30.6667 96 30C92.376 34.0157 84.3085 40.046 72.8325 43.5244C71.3732 41.9706 69.2999 41 67 41C64.9581 41 63.0948 41.765 61.6812 43.0241C58.9339 41.1174 55.5974 40 52 40C45.4772 40 39.8124 43.6736 36.9618 49.0648C34.7819 47.7539 32.229 47 29.5 47C21.4919 47 15 53.4919 15 61.5C15 69.5081 21.4919 76 29.5 76C34.2861 76 38.5307 73.6811 41.1714 70.1056C44.1122 72.5382 47.8854 74 52 74C61.3888 74 69 66.3888 69 57C69 56.916 68.9994 56.8321 68.9982 56.7484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.5507 36.0688C92.1787 34.6968 89.9576 34.7041 88.5766 36.0851C84.9828 39.6788 85.1077 44.5117 80.2428 49.3766C85.1077 44.5117 89.9406 44.6367 93.5344 41.0429C94.8997 39.6776 94.9227 37.4407 93.5507 36.0688Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5506 36.0691C92.6154 35.1339 91.1048 35.1228 90.1832 36.0443C87.7934 38.4341 87.9119 41.7078 84.6787 44.9411C87.9119 41.7078 91.1856 41.8263 93.5754 39.4365C94.497 38.515 94.4858 37.0044 93.5506 36.0691Z",
    fill: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.934 40.2181L89.2456 34.4774C88.9846 34.2165 88.9585 33.7729 89.2456 33.4859L90.3154 32.416L96.9955 39.1482L95.9256 40.2181C95.6647 40.479 95.195 40.479 94.934 40.2181Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.173 33.2763L108.66 42.1483C108.477 43.2181 107.851 44.1575 106.938 44.7054L98.118 50.0286C97.8309 50.2113 97.4656 50.0025 97.4395 49.6633L96.9959 38.9909L110.173 33.2763Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2906 19.2901L87.3926 20.7253C86.3228 20.908 85.3834 21.5342 84.8354 22.4475L79.4601 31.215C79.2774 31.5021 79.4862 31.8674 79.8254 31.8935L90.4717 32.4675L96.2906 19.2901Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.402 6.26845C111.895 5.09423 92.0896 17.9063 89.428 30.7445C89.3498 31.1359 89.428 31.5273 89.689 31.7882L97.5432 39.7469C97.8042 40.0078 98.1695 40.1122 98.587 40.0078C111.503 37.4767 124.472 17.7758 123.402 6.26845Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.402 6.26952C119.253 5.82592 114.009 7.26108 108.894 9.81828C106.963 7.67858 119.723 20.7516 119.723 20.7516C122.332 15.6372 123.794 10.4184 123.402 6.26952Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.963 25.5532C105.98 27.5707 109.251 27.5707 111.269 25.5532C113.286 23.5356 113.286 20.2645 111.269 18.2469C109.251 16.2293 105.98 16.2293 103.963 18.2469C101.945 20.2645 101.945 23.5356 103.963 25.5532Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.982 24.3795C109.599 26.2321 107.016 26.6235 105.137 25.2666C103.285 23.8837 102.893 21.3004 104.25 19.4216C105.633 17.569 108.216 17.1775 110.095 18.5344C111.974 19.9435 112.365 22.5268 110.982 24.3795Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.983 24.3792C111.557 23.5964 111.818 22.6571 111.818 21.7699C111.739 21.8481 111.661 21.9264 111.609 22.0308C111.296 22.4483 111.009 22.8919 110.539 23.1528C110.122 23.3616 109.574 23.3877 109.156 23.1789C108.556 22.8919 108.138 22.2135 107.512 21.9525C106.729 21.6394 105.842 22.1091 105.033 21.822C104.642 21.6916 104.355 21.4045 104.146 21.0914C103.99 20.8827 103.833 20.6217 103.807 20.3347C103.128 22.0569 103.65 24.0922 105.216 25.2403C106.99 26.6494 109.626 26.258 110.983 24.3792Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.174 19.5516C110.121 19.4994 110.043 19.4211 109.991 19.3689C109.913 19.2906 109.834 19.2645 109.756 19.2906C109.652 19.2906 109.6 19.3428 109.521 19.4211C109.391 19.5516 109.391 19.7603 109.521 19.8908L109.547 19.9169C109.6 19.9691 109.652 20.0213 109.704 20.0734C109.782 20.1517 109.861 20.1778 109.965 20.1778C110.069 20.1778 110.148 20.1517 110.226 20.0734C110.304 19.8908 110.304 19.682 110.174 19.5516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M109.182 18.8733C109.156 18.795 109.077 18.7167 108.999 18.6906C108.112 18.3253 107.12 18.3253 106.233 18.6906C106.051 18.7689 105.998 18.9777 106.051 19.1342C106.077 19.1603 106.077 19.2125 106.103 19.2386C106.207 19.343 106.338 19.3691 106.494 19.3169C107.225 19.0038 108.008 19.0038 108.712 19.2908C108.79 19.3169 108.895 19.3169 108.973 19.2908C109.051 19.2647 109.13 19.1864 109.156 19.1081C109.208 19.056 109.234 18.9777 109.182 18.8733Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.8891 29.493C90.4977 30.2497 90.1063 31.0586 89.741 31.8415L93.2115 35.3119C93.2637 35.1554 93.2898 34.9727 93.3159 34.8422C93.4202 34.4247 93.5507 34.0333 93.6812 33.6419C93.916 32.833 94.2291 32.0502 94.5423 31.2152C95.1946 29.6235 95.9513 28.0839 96.8385 26.5705C98.5868 23.5697 100.753 20.7777 103.258 18.2727C104.536 17.0462 105.841 15.8459 107.276 14.7761L107.798 14.3586L108.346 13.9672L109.442 13.1843L110.59 12.4537L111.164 12.0884L111.764 11.7492C114.843 9.92262 118.183 8.46136 121.602 7.28714C118.053 8.06995 114.556 9.21808 111.216 10.7315L110.59 10.9925L109.964 11.3056L108.711 11.9318L107.511 12.6103L106.911 12.9495L106.337 13.3148C104.745 14.2803 103.258 15.3501 101.77 16.5244C98.8478 18.8206 96.2384 21.5866 93.9682 24.6396C92.8462 26.1791 91.8024 27.7969 90.8891 29.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8711 42.4868C86.297 41.9127 86.3231 40.9994 86.845 40.4253L93.812 33.2495C94.647 32.3623 95.6125 31.5534 96.6562 30.875L100.831 28.0568L101.431 28.657L98.5872 32.8059C97.8827 33.8236 97.0998 34.763 96.1866 35.6241L88.9586 42.5389C88.3584 43.0869 87.4451 43.0608 86.8711 42.4868Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 23C79 24.12 78.12 25 77 25C75.88 25 75 24.12 75 23C75 21.88 75.88 21 77 21C78.12 21 79 21.88 79 23Z",
    fill: "#2457CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 44C134 44.56 133.56 45 133 45C132.44 45 132 44.56 132 44C132 43.44 132.44 43 133 43C133.56 43 134 43.44 134 44Z",
    fill: "#2457CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 11C81 11.56 80.56 12 80 12C79.44 12 79 11.56 79 11C79 10.44 79.44 10 80 10C80.56 10 81 10.44 81 11Z",
    fill: "#2457CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 27C63 27.56 62.56 28 62 28C61.44 28 61 27.56 61 27C61 26.44 61.44 26 62 26C62.56 26 63 26.44 63 27Z",
    fill: "#2457CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 92.0907,
    y1: 37.3521,
    x2: 93.6714,
    y2: 35.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5153,
    stopColor: "#C6DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8188,
    stopColor: "#ACD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 99.127,
    y1: 36.8649,
    x2: 107.025,
    y2: 44.7632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 84.765,
    y1: 22.3733,
    x2: 92.6634,
    y2: 30.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 106.454,
    y1: 6.19161,
    x2: 106.454,
    y2: 40.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2088,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6226,
    stopColor: "#DBEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#BFDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 113.17,
    y1: 5.11397,
    x2: 124.263,
    y2: 16.2062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 107.658,
    y1: 16.7516,
    x2: 107.605,
    y2: 27.0655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833177,
    stopColor: "#FCC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    stopColor: "#FDA729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7462,
    stopColor: "#FD9732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 107.632,
    y1: 17.732,
    x2: 107.632,
    y2: 26.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3525,
    stopColor: "#2255CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6915,
    stopColor: "#1B4AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 107.632,
    y1: 20.3669,
    x2: 107.632,
    y2: 26.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F38C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3481,
    stopColor: "#143FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8476,
    stopColor: "#2052CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2559CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 93.9489,
    y1: 28.0704,
    x2: 93.949,
    y2: 42.9285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningPaidPackage);
export default __webpack_public_path__ + "static/media/icon-warning-paid-package.c49ea38bcfff48e2f7f21389221fba06.svg";
export { ForwardRef as ReactComponent };